<svg width="40" height="33" viewBox="0 0 40 33" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M40 0H0C8.83656 0 16 7.16344 16 16V17C16 25.8366 8.83656 33 0 33H40C31.1634 33 24 25.8366 24 17V16C24 7.16344 31.1634 0 40 0Z"
    fill="#EEF0F7"
  />
</svg>
